import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from 'src/app/services/general.service';

@Component({
  selector: 'app-title-breadbreadcrumb',
  templateUrl: './title-breadbreadcrumb.component.html',
  styleUrls: ['./title-breadbreadcrumb.component.scss']
})
export class TitleBreadbreadcrumbComponent implements OnInit {

  constructor(
    private router: Router,
    public generalService: GeneralService) { }

  ngOnInit() {
    // console.clear();
    console.log(this.generalService.breadcrum)
  }

}
